var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 23,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9298 16.502V22.402C28.9298 22.842 28.4098 23.062 28.0898 22.772L26.3398 21.162C26.1498 20.982 25.8498 20.982 25.6598 21.162L23.9098 22.762C23.5898 23.062 23.0698 22.832 23.0698 22.402V16.502C23.0698 16.222 23.2898 16.002 23.5698 16.002H28.4298C28.7098 16.002 28.9298 16.222 28.9298 16.502Z",
    fill: "#F99808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.98 16.0628C30.69 16.0228 30.43 16.2728 30.43 16.5628V22.5828C30.43 23.3428 29.98 24.0328 29.28 24.3428C28.58 24.6428 27.77 24.5128 27.21 23.9928L26.34 23.1928C26.15 23.0128 25.86 23.0128 25.66 23.1928L24.79 23.9928C24.43 24.3328 23.96 24.5028 23.49 24.5028C23.23 24.5028 22.97 24.4528 22.72 24.3428C22.02 24.0328 21.57 23.3428 21.57 22.5828V16.5628C21.57 16.2728 21.31 16.0228 21.02 16.0628C18.22 16.4128 17 18.3028 17 21.0028V31.0028C17 34.0028 18.5 36.0028 22 36.0028H30C33.5 36.0028 35 34.0028 35 31.0028V21.0028C35 18.3028 33.78 16.4128 30.98 16.0628ZM31.5 32.7528H23C22.59 32.7528 22.25 32.4128 22.25 32.0028C22.25 31.5928 22.59 31.2528 23 31.2528H31.5C31.91 31.2528 32.25 31.5928 32.25 32.0028C32.25 32.4128 31.91 32.7528 31.5 32.7528ZM31.5 28.7528H27.25C26.84 28.7528 26.5 28.4128 26.5 28.0028C26.5 27.5928 26.84 27.2528 27.25 27.2528H31.5C31.91 27.2528 32.25 27.5928 32.25 28.0028C32.25 28.4128 31.91 28.7528 31.5 28.7528Z",
    fill: "#F99808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCertification);
export default __webpack_public_path__ + "static/media/logoCertification.3c68180a9d6486cc6b8ecf69f939101a.svg";
export { ForwardRef as ReactComponent };